import { useSelector } from "react-redux";
import Header from "../components/Header";
import LeftSidebar from "../components/LeftSidebar";
import RightSidebar from "../components/RightSidebar";
import SearchOverlay from "../components/SearchOverlay";
import DetailContent from "../components/DetailContent";
import Logo from "../components/Logo";
import Footer from "../components/Footer";

function DetailPage() {
  // Redux에서 검색창 열림 여부 가져오기
  const isSearchOpen = useSelector((state) => state.search.isSearchOpen);

  return (
    <div className="wrapper">
      {/* 검색창 */}
      {isSearchOpen && <SearchOverlay />}

      {/* 헤더 */}
      <Header />

      {/* 컨테이너 시작 */}
      <div className="container">
        {/* 왼쪽 aside */}
        <LeftSidebar />

        {/* 중앙 메인 콘텐츠 */}
        <main>
          {/* 로고 */}
          <Logo />
          {/* 중앙 메인 콘텐츠 */}
          <DetailContent />
          {/* Footer */}
          <Footer />
        </main>
        {/* 우측 aside */}
        <RightSidebar />
      </div>
    </div>
  );
}
export default DetailPage;
